import { render } from "./choiceYear.vue?vue&type=template&id=d5cc8c82&scoped=true"
import script from "./choiceYear.vue?vue&type=script&lang=js"
export * from "./choiceYear.vue?vue&type=script&lang=js"

import "./choiceYear.vue?vue&type=style&index=0&id=d5cc8c82&scoped=true&lang=css"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5cc8c82"]])

export default __exports__